import type { CSSProperties } from 'react';

interface ForbiddenIllustrationProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function ForbiddenIllustration({ size = 160, className, style }: ForbiddenIllustrationProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
    >
      <circle cx="80" cy="80" r="64" stroke="currentColor" strokeOpacity="0.18" strokeWidth="2" />
      <circle cx="80" cy="80" r="48" stroke="currentColor" strokeOpacity="0.32" strokeWidth="2" strokeDasharray="3 5" />
      <path
        d="M64 76V62a16 16 0 0 1 32 0v14"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <rect
        x="54"
        y="76"
        width="52"
        height="40"
        rx="6"
        stroke="currentColor"
        strokeWidth="3"
      />
      <circle cx="80" cy="94" r="4" fill="currentColor" />
      <path d="M80 98v6" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
